export const shadow = {
  none: "0 0 0 rgba(0,0,0,0)",
  sm: "0 2px 4px rgba(0,0,0,0.25)",
  md: "0 6px 12px rgba(0,0,0,0.3)",
  lg: "0 12px 28px rgba(0,0,0,0.35)"
};
